import React from 'react';
import { Pie } from '@ant-design/plots';

const data = [
	{
		type: 'Enrolled',
		value: 27,
	},
	{
		type: 'Passed',
		value: 25,
	},
	{
		type: 'Failed',
		value: 18,
	}
];
const config = {
	appendPadding: 10,
	data,
	angleField: 'value',
	colorField: 'type',
	radius: 0.75,
	label: {
		type: 'spider',
		labelHeight: 28,
		content: '{name}\n{percentage}',
	},
	interactions: [
		{
			type: 'element-selected',
		},
		{
			type: 'element-active',
		},
	],
};

export default function PlotPie() {
  return (
		<div className="PlotPie">
			<Pie {...config} />
		</div>
  )
}